import { autoinject } from "aurelia-framework";

/**
 * Custom element that renders a badge.
 */
@autoinject
export class BadgeCustomElement
{
}
